export default "__VITE_PUBLIC_ASSET__f460a1fe__"